import type { IconNode } from '../types';

/**
 * @name football-goal
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuNyAyLjNjLS4yLS4yLS45LS40LTEuNy0uM2E0LjYgNC42IDAgMCAwLTMuNyA1LjdjLjMuMi45LjQgMS43LjNhNC42IDQuNiAwIDAgMCAzLjctNS43IiAvPgogIDxwYXRoIGQ9Ik0yMCAydjljMCAuNi0uNCAxLTEgMUg1Yy0uNiAwLTEtLjQtMS0xVjIiIC8+CiAgPHBhdGggZD0iTTE0IDE2YTQgNCAwIDAgMC00LTQiIC8+CiAgPHBhdGggZD0iTTEzIDE2Yy0uNiAwLTEgLjQtMSAxdjRjMCAuNi40IDEgMSAxaDJjLjYgMCAxLS40IDEtMXYtNGMwLS42LS40LTEtMS0xWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/football-goal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const footballGoal: IconNode = [
  [
    'path',
    {
      d: 'M15.7 2.3c-.2-.2-.9-.4-1.7-.3a4.6 4.6 0 0 0-3.7 5.7c.3.2.9.4 1.7.3a4.6 4.6 0 0 0 3.7-5.7',
      key: 'qfa2jo',
    },
  ],
  ['path', { d: 'M20 2v9c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V2', key: '1imxo' }],
  ['path', { d: 'M14 16a4 4 0 0 0-4-4', key: '7vor0k' }],
  [
    'path',
    { d: 'M13 16c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1Z', key: 'nsaxbz' },
  ],
];

export default footballGoal;
